import React, { useState } from "react";
import {
  Icon,
  IconButton,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  useToast,
} from "@chakra-ui/react";
import { FaPen } from "react-icons/fa";
import { useSession } from "contexts/SessionContext";

// Bouton crayon + modal pour modifier son prénom / nom. Disponible pour tout rôle.
export default function EditNameButton({ size = "sm", color = "gray.500" }) {
  const { profile, updateProfile } = useSession();
  const toast = useToast();
  const [open, setOpen] = useState(false);
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");

  function ouvrir() {
    const parts = ((profile && profile.full_name) || "").trim().split(/\s+/);
    setPrenom(parts[0] || "");
    setNom(parts.slice(1).join(" "));
    setOpen(true);
  }

  async function enregistrer() {
    const full = `${prenom.trim()} ${nom.trim()}`.trim();
    if (!full) return toast({ title: "Renseignez votre nom.", status: "warning", duration: 2000 });
    const { error } = await updateProfile({ full_name: full });
    if (error) return toast({ title: "Modification impossible", description: error.message, status: "error", duration: 3000 });
    toast({ title: "Profil mis à jour", status: "success", duration: 2000 });
    setOpen(false);
  }

  return (
    <>
      <IconButton aria-label="Modifier mon profil" icon={<Icon as={FaPen} fontSize="12px" />} size={size} variant="ghost" color={color} _hover={{ color: "teal.500", bg: "teal.50" }} onClick={ouvrir} />
      <Modal isOpen={open} onClose={() => setOpen(false)} isCentered size="md">
        <ModalOverlay />
        <ModalContent borderRadius="15px">
          <ModalHeader>Modifier mon profil</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="14px">
              <FormControl><FormLabel fontSize="sm" fontWeight="bold">Prénom</FormLabel><Input value={prenom} onChange={(e) => setPrenom(e.target.value)} borderRadius="12px" fontSize="sm" /></FormControl>
              <FormControl><FormLabel fontSize="sm" fontWeight="bold">Nom</FormLabel><Input value={nom} onChange={(e) => setNom(e.target.value)} borderRadius="12px" fontSize="sm" /></FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button variant="outline" borderRadius="12px" mr="10px" onClick={() => setOpen(false)}>Annuler</Button>
            <Button bg="teal.300" color="white" _hover={{ bg: "teal.400" }} borderRadius="12px" onClick={enregistrer}>Enregistrer</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
